import { render, staticRenderFns } from "./PromoteSales.vue?vue&type=template&id=1190574c&"
import script from "./PromoteSales.vue?vue&type=script&lang=js&"
export * from "./PromoteSales.vue?vue&type=script&lang=js&"
import style0 from "./PromoteSales.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports